import { CollectionFilterKey, CollectionFilterValue } from '@web/common';

export class TableFilterChangeEvent<Filter> {
  public constructor(
    public readonly key: CollectionFilterKey<Filter>,
    public readonly value: CollectionFilterValue,
  ) {}
}
